var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import { ESocketEventMessage, ESocketSource, } from "../../types/socket.types";
import { showAlert } from "../../utils/alert/alert.utils";
import { socketMessageReceived, } from "../socket/socket.actions";
import * as notificationActions from "./notification.actions";
function socketMessageReceivedFlow(_a) {
    var data, jsonData, source, event_1, socketPayload, _b, notification, unknownError_1, error;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 7]);
                data = payload.data;
                jsonData = JSON.parse(data);
                if (!jsonData) {
                    throw Error("Could not parse socket message in socketMessageReceivedFlow");
                }
                source = jsonData.source, event_1 = jsonData.event, socketPayload = jsonData.message;
                if (source !== ESocketSource.System) {
                    return [2 /*return*/];
                }
                _b = event_1;
                switch (_b) {
                    case ESocketEventMessage.Notification: return [3 /*break*/, 1];
                }
                return [3 /*break*/, 4];
            case 1:
                if (!socketPayload) return [3 /*break*/, 3];
                notification = socketPayload;
                return [4 /*yield*/, put(notificationActions.notificationReceived(notification))];
            case 2:
                _c.sent();
                showAlert({
                    type: notification.type,
                    message: notification.text,
                });
                _c.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4: return [3 /*break*/, 5];
            case 5: return [3 /*break*/, 7];
            case 6:
                unknownError_1 = _c.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(socketMessageReceived.getType(), socketMessageReceivedFlow)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
